import styles from './Profil.module.css'
import { ImMobile } from "react-icons/im";
import { IoMailOutline } from "react-icons/io5";
import { IoIosContact } from "react-icons/io";

export default function Profil({name, image, title, mobile, mail, info, addInfo}) {

    return(
        <div className={styles.profilBox}>
            
            {image ? (
                <div className={styles.img} style={{ backgroundImage: `url(${image})` }}></div>
            ) : (
                <div className={styles.img} style={{ display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <IoIosContact size={100} color="#666" />
                </div>
            )}
            <h4 className={styles.title}>{title}</h4>
            <h4 className={styles.name}>{name}</h4>
            {info &&  <div className={styles.info}> 
                            <p>{info}</p>
                        </div>
            }
            {mail &&  <div className={styles.mail}>
                            <IoMailOutline className={styles.mailIcon}></IoMailOutline> 
                            <p>{mail}</p>
                        </div>
            }
            {mobile &&  <div className={styles.mobile}>
                            <ImMobile className={styles.mobileIcon}></ImMobile> 
                            <p>{mobile}</p>
                        </div>
            }
            {addInfo &&  <div className={styles.addInfo}> 
                            <p>{addInfo}</p>
                        </div>
            }
        </div>
    );
}